/* ============================================================================
   kenania-collection.js — مبدّل كثافة شبكة المنتجات

   يبني أزرار اختيار عدد المنتجات في الصف (2 إلى 6 + عرض قائمة)
   ويحقنها في شريط الأدوات، ويحفظ اختيار الزائر في localStorage.

   يعمل على أصناف Bootstrap الموجودة (row-cols-lg-N / row-cols-xl-N)
   بدل بناء شبكة جديدة — فلا يتعارض مع إعدادات الثيم ولا مع
   التحميل اللانهائي الذي يعيد رسم الشبكة.
   ============================================================================ */
(function () {
  'use strict';

  // صفحة قائمة المجموعات لها شبكة أقل كثافة ومفتاح تخزين مستقل،
  // حتى لا يتداخل اختيار الزائر بين الصفحتين.
  var IS_COLLECTION_LIST = !document.querySelector('#ProductGridContainer');

  var STORAGE_KEY = IS_COLLECTION_LIST ? 'kn:collections-density:v1' : 'kn:grid-density:v2';
  var OPTIONS = IS_COLLECTION_LIST ? [1, 2, 3, 4, 5] : [1, 2, 3, 4, 5, 6];
  var DEFAULT = IS_COLLECTION_LIST ? 3 : 4;

  function findGrid() {
    return document.querySelector(
      '[id="ProductGridContainer"] .row[class*="row-cols"], #product-grid, .product-grid, #MainContent .row[class*="row-cols"]'
    );
  }

  /* صفحة المجموعات لا تملك شريط أدوات، فنبنيه فوق الشبكة. */
  function buildToolbar(grid) {
    var bar = document.createElement('div');
    bar.className = 'kn-toolbar';
    grid.parentNode.insertBefore(bar, grid);
    return bar;
  }

  function applyDensity(grid, n) {
    if (!grid) return;
    // نزيل أصناف الأعمدة للشاشات الكبيرة فقط، ونترك الموبايل كما ضبطه الثيم
    grid.className = grid.className
      .replace(/\brow-cols-lg-\d+\b/g, '')
      .replace(/\brow-cols-xl-\d+\b/g, '')
      .trim();
    grid.classList.add('row-cols-lg-' + Math.min(n, 4));
    grid.classList.add('row-cols-xl-' + n);
    grid.classList.toggle('kn-grid--list', n === 1);
  }

  function save(n) {
    try { localStorage.setItem(STORAGE_KEY, String(n)); } catch (e) {}
  }
  function load() {
    try {
      var v = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      return OPTIONS.indexOf(v) > -1 ? v : DEFAULT;
    } catch (e) { return DEFAULT; }
  }

  function buildSwitcher(current) {
    var wrap = document.createElement('div');
    wrap.className = 'kn-density';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'عدد المنتجات في الصف');

    OPTIONS.forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kn-density__btn';
      b.dataset.cols = String(n);
      b.setAttribute('aria-label', n === 1 ? 'عرض قائمة' : n + ' في الصف');
      b.setAttribute('aria-pressed', n === current ? 'true' : 'false');

      if (n === 1) {
        // عمود واحد = عرض قائمة، فأيقونته أسطر أفقية لا شريط واحد
        b.classList.add('kn-density__btn--list');
        for (var j = 0; j < 3; j++) b.appendChild(document.createElement('span'));
      } else {
        // أشرطة رأسية بعدد الأعمدة
        for (var i = 0; i < n; i++) b.appendChild(document.createElement('span'));
      }
      wrap.appendChild(b);
    });
    return wrap;
  }

  function init() {
    var grid = findGrid();
    if (!grid) return;

    // شريط الأدوات الذي يحوي الترتيب وعدد المنتجات
    var toolbar = document.querySelector('.product-grid-container .d-flex.align-items-center.justify-content-between');
    if (!toolbar) toolbar = buildToolbar(grid);
    if (toolbar.querySelector('.kn-density')) return;

    var current = load();
    var switcher = buildSwitcher(current);

    // في المنتصف بين زر الفلتر وقائمة الترتيب
    if (toolbar.lastElementChild) {
      toolbar.insertBefore(switcher, toolbar.lastElementChild);
    } else {
      toolbar.appendChild(switcher);
    }
    applyDensity(grid, current);

    switcher.addEventListener('click', function (e) {
      var btn = e.target.closest('.kn-density__btn');
      if (!btn) return;
      var n = parseInt(btn.dataset.cols, 10);
      applyDensity(findGrid(), n);
      save(n);
      switcher.querySelectorAll('.kn-density__btn').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
    });

    // التحميل اللانهائي والفلترة يعيدان بناء الشبكة، فنعيد تطبيق الاختيار
    new MutationObserver(function () {
      var g = findGrid();
      if (g && !g.className.match(new RegExp('row-cols-xl-' + load() + '\\b'))) {
        applyDensity(g, load());
      }
    }).observe(document.querySelector('#ProductGridContainer') || grid.parentNode, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
